import React from 'react';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../ui/dialog';
import { Send } from 'lucide-react';

const BuyerMessageModal = ({
  open, onOpenChange, messageBooth, messageToExhibitor, setMessageToExhibitor,
  user, startConversation, t,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Send className="h-5 w-5" />{t('dashboard.send_message_to', { company: messageBooth?.company_name })}</DialogTitle>
          <DialogDescription>{t('dashboard.start_conversation')}</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div className="bg-slate-50 rounded-lg p-3">
            <p className="font-medium">{messageBooth?.company_name}</p>
            <p className="text-sm text-slate-500">{messageBooth?.seller?.company_info?.industry}</p>
          </div>
          <div>
            <Label>{t('dashboard.your_message')}</Label>
            <Textarea value={messageToExhibitor} onChange={(e) => setMessageToExhibitor(e.target.value)} placeholder={t('dashboard.type_message')} rows={4} />
          </div>
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 text-sm">
            <p className="text-blue-800"><strong>Your profile will be shared:</strong> {user?.name}, {user?.email}{user?.company && `, ${user.company}`}</p>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => { onOpenChange(false); setMessageToExhibitor(''); }}>{t('common.cancel')}</Button>
          <Button onClick={startConversation}><Send className="h-4 w-4 mr-1" /> {t('dashboard.send_message_btn')}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default BuyerMessageModal;
